import React, { Component, Fragment } from 'react';
import { Query, Mutation } from 'react-apollo';
import gql from 'graphql-tag';
import { Link, Switch, Route, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import Select from 'react-select';
import format from 'date-fns/format';

import ArchivedMessage from './ArchivedMessage';

import ArchiveChatButton from '../../../components/ArchiveChatButton';
import AnalyseChatButton from '../../../components/AnalyseChatButton';
import DeleteChatButton from '../../../components/DeleteChatButton';

import Tippy from '../../../utils/Tippy';
import Icon, {
  UserIcon,
  ClipboardIcon,
  ChatIcon,
  QuoteIcon,
  ArchiveIcon,
  ThrashIcon,
  ThumbsUpIcon,
  ThumbsDownIcon,
} from '../../../utils/icons';

const CHAT_QUERY = gql`
  query Chat($id: Int!) {
    chat(id: $id) {
      id
      status
      messages {
        id
        approved
        text
        sender
        source
        sent
      }
      created
    }
  }
`;

const ARCHIVE_CHAT_MUTATION = gql`
  mutation archiveChat($session: Int!) {
    archiveChat(session: $session)
  }
`;

const ANALYSE_CHAT_MUTATION = gql`
  mutation analyseChat($session: Int!) {
    analyseChat(session: $session)
  }
`;

const DELETE_CHAT_MUTATION = gql`
  mutation deleteChat($session: Int!) {
    deleteChat(session: $session)
  }
`;

const ArcivedChat = props => {
  const { chatId } = props.match.params;
  const id = parseInt(chatId, 10);

  if (!id) {
    return <div className="chat-info" />;
  }

  return (
    <Query query={CHAT_QUERY} fetchPolicy="cache-first" variables={{ id }}>
      {({ loading, error, data }) => {
        if (error) return null;
        if (loading)
          return (
            <div className="chat-info">
              <div className="chat-info-header" />
            </div>
          );

        const { chat } = data;

        const actionClasses = classNames({
          'chat-info-header-actions': true,
          'chat-info-header-actions-archived': chat.status === 'ARCHIVED',
          'chat-info-header-actions-analysed': chat.status === 'ANALYSED',
          'chat-info-header-actions-deleted': chat.status === 'DELETED',
        });

        return (
          <div className="chat-info">
            <div className="chat-info-header">
              <div className="chat-info-header-title">
                {`Logi #${chat.id}: ${chat.status}`}
                <div className="chat-info-header-created">
                  {format(chat.created, 'DD.MM.YYYY, HH:mm')}
                </div>
              </div>
              <div className={actionClasses}>
                <ArchiveChatButton
                  chatId={chat.id}
                  active={chat.status === 'ARCHIVED'}
                />
                <AnalyseChatButton
                  chatId={chat.id}
                  active={chat.status === 'ANALYSED'}
                />
                <DeleteChatButton
                  chatId={chat.id}
                  active={chat.status === 'DELETED'}
                />
              </div>
            </div>
            <div className="chat-info-log">
              <div className="chat-messages">
                <div className="chat-message-bot" />
                {chat.messages &&
                  chat.messages.map(message => (
                    <ArchivedMessage
                      key={message.id}
                      chatId={chat.id}
                      {...message}
                    />
                  ))}
              </div>
            </div>
          </div>
        );
      }}
    </Query>
  );
};

export default withRouter(ArcivedChat);
